import axios from 'axios';
import { url } from '../config';

//Redux Actions
import { FETCH_POSTS_START, FETCH_POST } from '../actions/';

// Axios Request
export const fetchSinglePost = (post_type, postSlug) => {
    return function (dispatch) {
        dispatch({ type: FETCH_POSTS_START });
        axios
            .get(`${url}/wp-json/wp/v2/${post_type}?slug=${postSlug}`)
            .then((response) => {
                dispatch({
                    type: FETCH_POST,
                    payload: response.data,
                });
            });
    };
};



// WEBPACK FOOTER //
// ./src/requests/singlepost_request.js